export default __webpack_public_path__ + "static/media/Organization_Filled_Active.1b218216.svg";